export interface EventItem {
  /** id of the custom event */
  id?: number;

  /** Specifies if the event is a custom event */
  custom?: boolean;

  /** Specifies if the event is a collect everything event */
  isCollectEverything?: boolean;

  /** The API value of the event */
  value: any;

  /** The display name of the event */
  label: string;

  /** The renamed label for the event */
  renamed?: string;
}

export type EventItemProps = Array<keyof EventItem>;

export const EVENT_PROPERTIES: EventItemProps = [`id`, `custom`, `label`, `value`, `renamed`, `isCollectEverything`];

export interface EventsMenu {
  isContentSearchable(): boolean;
  isInnerContentSearchable(): boolean;
}
